import { reqGetData, getFields } from "../../fn/req";
import store from "../../redux/store";

import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import { dataFilter, getTabs, getItem, saveData, updateData } from "../../fn/data";
import { setAlert, setItem } from "../../redux/actions/menu";
import { Redirect } from "react-router";

const { Grid, Typography, Dialog, DialogContent, DialogTitle } = require("@material-ui/core");
const { Component } = require("react");
const { default: TableShow } = require("../data/dataShow/table");
const { default: Actions } = require("../Menu/Actions");
const { default: Header } = require("../Menu/Header");
const { default: Inputs } = require("../data/dataInput/inputs");
const { default: Search } = require("../Search");

class Farms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      farms: [],
      form: {},
      fields: [],
      filteredFarms: [],
      searchedValue: null,
      redirect: false,
      redirectTo: "",
      modal: {
        open: false,
      },
      actions: [],
    };
  }

  componentDidMount() {
    reqGetData({ target: "farms" }, cb => {
      this.setState({ farms: cb });
    });

    //get fields
    getFields({ target: "farms", tab: "overview" }, cb => {
      let tempState = { fields: cb.fields, allowDelete: cb.allowDelete, allowAdd: cb.allowAdd };

      if (cb.allowAdd) {
        // add add button
        tempState.actions = [
          {
            value: "add",
            alias: "Add new farm",
            action: this.addNewFarm.bind(this),
            startIcon: <AddIcon />,
          },
        ];
      }

      this.setState(tempState);
    });

    this.unsubscribe = store.subscribe(() => {
      let state = store.getState();
      let searchedValue = state.menu.filter ? state.menu.filter.searchedValue : null;
      if (searchedValue && searchedValue !== this.state.searchedValue) {
        dataFilter({ data: this.state.farms, filter: searchedValue }, cb => {
          this.setState({ searchedValue, filteredFarms: cb });
        });
      }

      if (!searchedValue) {
        this.setState({ searchedValue });
      }
    });
  }

  handleAction(opt) {
    let type = opt.type;
    switch (type) {
      case "view":
        store.dispatch(
          setItem({
            tab: 3,
            type: "view",
            titleFields: ["farmName"],
            data: getItem({ data: this.state.farms, id: opt.id }),
            origin: "farms",
            tabs: getTabs({ target: "farms" }),
          })
        );
        this.setState({
          redirect: true,
          redirectTo: "/item",
        });
        break;
      case "delete":
        this.setState({
          modal: {
            open: true,
            text: "Are you sure?",
            title: "Delete farm",
            actions: [
              {
                value: "close",
                alias: "Close",
                action: () => this.setState({ modal: { open: false } }),
                color: "secondary",
                startIcon: <CloseIcon />,
              },
              {
                value: "delete",
                alias: "YES",
                action: () =>
                  this.deleteItem({
                    id: opt.id,
                    target: "farms",
                  }),
                color: "secondary",
                startIcon: <DeleteIcon />,
              },
            ],
          },
        });
        break;

      default:
        break;
    }
  }

  deleteItem = opt => {
    updateData(
      {
        target: opt.target,
        id: opt.id,
        data: { itemState: false },
      },
      cb => {
        if (cb) {
          this.setState({ farms: cb, modal: { open: false } });
          store.dispatch(
            setAlert({
              text: "Item deleted",
              open: true,
              timeout: 2000,
              severity: "success",
            })
          );
        } else {
          // not able to delete
          this.setState({ modal: { open: false } });
          store.dispatch(
            setAlert({
              text: "Not able to delete item",
              open: true,
              timeout: 2000,
              severity: "error",
            })
          );
        }
      }
    );
  };

  componentWillUnmount() {
    this.unsubscribe();
  }

  saveData(opt) {
    saveData({ target: "farms", data: this.state.form }, cb => {
      if (cb) {
        this.setState(
          {
            farms: cb,
            modal: { open: false },
            form: {},
          },
          () => {
            store.dispatch(
              setAlert({
                text: "Farm saved",
                open: true,
                timeout: 2000,
                severity: "success",
              })
            );
          }
        );
      } else {
        store.dispatch(
          setAlert({
            text: "Not able to add farm",
            open: true,
            timeout: 2000,
            severity: "error",
          })
        );
      }
    });
  }

  addNewFarm(opt) {
    let inputs = [...this.state.fields].map(f => {
      let newF = { ...f };
      newF.disabled = false;
      return newF;
    });

    this.setState({
      modal: {
        open: true,
        title: "Add new farm",
        inputs,
        actions: [
          {
            value: "close",
            alias: "Close",
            action: () => this.setState({ modal: { open: false } }),
            color: "secondary",
            startIcon: <CloseIcon />,
          },
          {
            value: "save",
            alias: "Save",
            color: "primary",
            action: this.saveData.bind(this),
            startIcon: <SaveIcon />,
          },
        ],
      },
    });
  }

  handleChange(opt) {
    let form = { ...this.state.form };
    form[opt.target] = opt.value;
    this.setState({ form });
  }

  mainComp = opt => {
    let modal = opt.modal;
    let data = opt.data;

    return (
      <Grid container>
        <Header tab={1} />
        <Grid container item>
          <Grid item xs={12} md={6} lg={6} className='my-3'>
            <Typography align='center' variant='h4' className='text-Pmain'>
              {"Farms List"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={3} className='my-3'>
            <Search />
          </Grid>
          <Grid item xs={12} md={6} lg={3} className='my-3'>
            <Actions actions={this.state.actions} />
          </Grid>
        </Grid>
        <Grid xs={12} item>
          <TableShow
            headFilters
            tableProps={{ size: "small" }}
            heads={this.state.tableHeads}
            lines={data ? data : []}
          />
        </Grid>
        <Dialog open={modal.open} onClose={() => this.setState({ modal: { open: false } })}>
          <DialogTitle>{modal.title}</DialogTitle>
          <DialogContent>
            <Inputs
              inputs={modal.inputs}
              values={this.state.form}
              handleChange={this.handleChange.bind(this)}
            />
          </DialogContent>
          <Grid className='m-2'>
            <Actions actions={modal.actions} />
          </Grid>
        </Dialog>
      </Grid>
    );
  };

  render() {
    let modal = this.state.modal;
    let filter = this.state.searchedValue;

    if (this.state.redirect) {
      return <Redirect to={this.state.redirectTo} />;
    } else {
      var fields = [...this.state.fields];
      fields.push({
        value: "actions",
        alias: "Actions",
        type: "actions",
        variants: [
          {
            value: "view",
            alias: "View",
            icon: "visibility",
            action: opt => this.handleAction({ id: opt, type: "view" }),
          },
          {
            value: "delete",
            alias: "delete",
            icon: "delete",
            action: opt => this.handleAction({ id: opt, type: "delete" }),
          },
        ],
      });

      return (
        <Grid container>
          <Header tab={3} />
          <Grid container item>
            <Grid item xs={12} md={6} lg={6} className='my-3'>
              <Typography variant='h4' align='center' className='my-3 text-Pmain'>
                {"Farms List"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={3} className='my-3'>
              <Search />
            </Grid>
            <Grid item xs={12} md={6} lg={3} className='my-3'>
              <Actions actions={this.state.actions} />
            </Grid>
          </Grid>
          <Grid xs={12} item>
            <TableShow
              tableProps={{ size: "small" }}
              headFilters
              allowDelete={this.state.allowDelete}
              heads={fields}
              lines={filter ? this.state.filteredFarms : this.state.farms}
            />
          </Grid>
          <Dialog
            open={modal.open}
            onClose={() => this.setState({ modal: { open: false } })}
            fullWidth={true}
            maxWidth={"md"}
          >
            <DialogTitle>{modal.title}</DialogTitle>
            {modal.text ? (
              <Typography variant='h4' align='center'>
                {modal.text}
              </Typography>
            ) : null}
            <DialogContent>
              <Inputs
                inputs={modal.inputs}
                values={this.state.form}
                handleChange={this.handleChange.bind(this)}
              />
            </DialogContent>
            <Grid className='m-2'>
              <Actions actions={modal.actions} />
            </Grid>
          </Dialog>
        </Grid>
      );
    }
  }
}

export default Farms;
